<template>
  <div>
    <transition-group
      v-if="!checkIsMobile() && !checkIsTablet()"
      name="card-in-out"
    >
      <v-card
        class="tournament-card-preview"
        elevation="1"
        v-for="(object, index) in getPreview"
        :key="'default_preview_' + object.source"
      >
        <div class="tournament-card-header">
          <span class="sport-text" :title="object.sport.name">
            <img
              v-if="object.sport.name.includes('Antepost')"
              :src="sportPath + 'antepost.svg'"
              :alt="'Antepost' + object.sport.name"
            />
            <img
              v-else
              :src="sportPath + object.sport.id + '.svg'"
              :alt="object.sport.name"
              v-bind:class="{ 'img-sport-light': light }"
            />
            {{ object.sport.name }}
          </span>
          <span class="category-text" :title="object.category.name">
            <v-icon dense>mdi-chevron-right</v-icon>
            <img
              :src="categoryPath + object.category.id + '.svg'"
              :alt="object.category.name"
            />
            {{ object.category.name }}
          </span>
          <span
            v-if="object.type == 'prematch'"
            class="tournament-text highlight"
            :title="object.tournament.name"
          >
            <v-icon dense>mdi-chevron-right</v-icon>
            {{ object.tournament.name }}
          </span>
          <span
            v-else-if="object.type == 'antepost'"
            class="tournament-text highlight"
            :title="object.desc.name"
          >
            <v-icon dense>mdi-chevron-right</v-icon>
            {{ object.desc.name }}
          </span>
          <span class="close-card">
            <v-icon dense @click="removePreview(object.source)"
              >mdi-close-box</v-icon
            >
          </span>
        </div>

        <div
          v-if="object.type == 'prematch'"
          class="tournament-card-events"
          v-for="(group, date) in groupByDate(object.events)"
          :key="$uuid.v1()"
        >
          <div class="bar-info">
            <v-col cols="12" md="5" class="no-padding">
              <span class="date">{{ date }}</span>
            </v-col>
            <v-col
              cols="12"
              :md="object.markets_count == 1 ? 6 : 3"
              class="no-padding group-sign"
              v-for="(market, index) in object.markets"
              :key="$uuid.v1()"
              v-if="index < 2"
            >
              <span
                class="sign"
                v-for="(outcome, index) in market.outcomes"
                :key="$uuid.v1()"
              >
                {{ outcome.name }} {{ getSpecifiers(market.specifiers) }}
              </span>
            </v-col>
            <!-- use this if take configuration from market view settings -->
            <!--                        <v-col cols="12" :md="(object.headerSign == 1)? 6 : 3" class="no-padding group-sign"-->
            <!--                               v-for="(elemMarket,index) in object.headerSign" :key="'default_header_'+index" v-if="index <2">-->
            <!--                          <span class="sign" v-for="(outcome,index) in elemMarket.outcomeNames" :key="'default_header_outcome_mobile_'+index">-->
            <!--                          {{ outcome }}-->
            <!--                          </span>-->
            <!--                        </v-col>-->

            <v-col cols="12" md="1" class="no-padding"> </v-col>
          </div>
          <div
            class="event"
            v-for="(event, index) in group"
            :key="$uuid.v1()"
            :class="index % 2 == 0 ? 'even' : 'odd'"
          >
            <template
              v-if="new Date(event.scheduled).getTime() > new Date().getTime()"
            >
              <v-col cols="12" md="5" class="no-padding info-event">
                <span class="info-match">
                  <span class="time">{{
                    new Date(event.scheduled).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                    })
                  }}</span>
                  <span
                    v-if="
                      getUserType == 4 ||
                      getCashier ||
                      !getSettings.enableQuickBetOnlyForAgency
                    "
                    class="event-qbet"
                    title="qbet"
                  >
                    {{ event.quickbet }}
                  </span>
                </span>
                <span class="competitors">
                  <span class="home">{{ event.competitors.home.name }}</span>
                  <span class="away">{{ event.competitors.away.name }}</span>
                </span>
              </v-col>
              <v-col
                cols="12"
                :md="object.markets_count == 1 ? 6 : 3"
                class="no-padding group-sign"
                v-for="(oddMarket, index) in event.odds"
                :key="$uuid.v1()"
                v-if="index < 2"
              >
                <div
                  v-if="!oddMarket.void"
                  class="odd"
                  v-for="(odd, index) in oddMarket.odds"
                  :key="$uuid.v1()"
                >
                  <v-icon class="arrow-up" v-if="odd.type_change == 'up'"
                    >mdi-arrow-up</v-icon
                  >
                  <v-icon class="arrow-down" v-if="odd.type_change == 'down'"
                    >mdi-arrow-down</v-icon
                  >
                  <div
                    v-if="odd.outcome_odd_value > 0 && odd.active"
                    class="value"
                    :class="[
                      'multi-' + oddMarket.multiplicity_min,
                      odd.type_change != undefined ? odd.type_change : 'equal',
                      getOddsSources.includes(odd.unique_id)
                        ? 'odd_selected'
                        : '',
                    ]"
                    @click="
                      putCart(
                        odd,
                        event,
                        object.sport,
                        object.category,
                        object.tournament
                      )
                    "
                  >
                    {{ odd.outcome_odd_value | odds_type_filter }}
                  </div>
                  <div
                    v-else
                    class="value"
                    :class="'multi-' + oddMarket.multiplicity_min"
                  >
                    <v-icon dense>mdi-lock</v-icon>
                  </div>
                </div>

                <div
                  v-if="oddMarket.void"
                  class="odd"
                  v-for="n in oddMarket.n_outcomes"
                  :key="$uuid.v1()"
                >
                  <div
                    class="value locked"
                    :class="'multi-' + oddMarket.multiplicity_min"
                  >
                    <v-icon dense>mdi-lock</v-icon>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="1" class="no-padding group-sign">
                <div class="odd">
                  <div
                    v-if="event.count_odds > 0"
                    class="value"
                    @click="
                      getDetailOfEvent(
                        event.id,
                        event.type,
                        object.sport.id,
                        object.tournament.id ? object.tournament.id : '',
                        event.status
                      )
                    "
                    v-bind:class="{
                      'detail-opened': getEventsDetailActive.includes(event.id),
                    }"
                  >
                    <span v-if="getOddsType == 'decimal'"
                      >+ {{ event.count_odds }}</span
                    >
                    <span v-if="getOddsType == 'american'">{{
                      $t('moreBets')
                    }}</span>
                  </div>
                  <div v-else class="value locked">
                    <v-icon dense>mdi-lock</v-icon>
                  </div>
                </div>
              </v-col>
            </template>
          </div>
        </div>
        <div
          v-else-if="object.type == 'antepost'"
          class="tournament-card-events"
        >
          <div
            v-for="(oddMarket, index) in object.events.odds"
            class="antepost-event"
            v-if="oddMarket.odds.length > 0"
            :key="$uuid.v1()"
          >
            <div class="bar-info">
              <v-col
                cols="12"
                md="12"
                class="no-padding"
                :title="oddMarket.name_market"
              >
                <span class="date">
                  {{ oddMarket.name_market }}
                </span>
              </v-col>
            </div>

            <v-row class="antepost-group-sign no-padding no-margin">
              <v-col
                cols="12"
                md="4"
                v-if="!oddMarket.void"
                class="odd-antepost"
                :class="[
                  getOddsSources.includes(odd.unique_id) ? 'odd_selected' : '',
                ]"
                v-for="(odd, index) in oddMarket.odds"
                :key="$uuid.v1()"
                :title="odd.outcome_name + ' - ' + oddMarket.name_market"
                @click="
                  putCart(
                    odd,
                    object.events,
                    object.sport,
                    object.category,
                    object.tournament
                  )
                "
              >
                <div class="outcome-name">
                  {{ odd.outcome_name }}
                </div>
                <div
                  v-if="odd.outcome_odd_value > 0"
                  class="value"
                  :class="'multi-' + oddMarket.multiplicity_min"
                >
                  {{ odd.outcome_odd_value | odds_type_filter }}
                </div>
                <div
                  v-else
                  class="value"
                  :class="'multi-' + oddMarket.multiplicity_min"
                >
                  <v-icon dense>mdi-lock</v-icon>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
    </transition-group>
    <transition-group
      v-else-if="checkIsMobile() || checkIsTablet()"
      name="card-in-out"
    >
      <v-card
        class="tournament-card-preview preview-mobile"
        elevation="1"
        v-for="(object, index) in getPreview"
        :key="$uuid.v1()"
      >
        <div class="tournament-card-header">
          <span class="sport-text" :title="object.sport.name">
            <img
              v-if="object.sport.name.includes('Antepost')"
              :src="sportPath + 'antepost.svg'"
              :alt="'Antepost' + object.sport.name"
            />
            <img
              v-else
              :src="sportPath + object.sport.id + '.svg'"
              :alt="object.sport.name"
              v-bind:class="{ 'img-sport-light': light }"
            />
          </span>
          <span class="category-text" :title="object.category.name">
            <img
              :src="categoryPath + object.category.id + '.svg'"
              :alt="object.category.name"
            />
          </span>
          <span
            v-if="object.type == 'prematch'"
            class="tournament-text highlight"
            :title="object.tournament.name"
          >
            {{ object.tournament.name }}
          </span>
          <span
            v-else-if="object.type == 'antepost'"
            class="tournament-text highlight"
            :title="object.desc.name"
          >
            <v-icon dense>mdi-chevron-right</v-icon>
            {{ object.desc.name }}
          </span>
          <span class="close-card">
            <v-icon dense @click="removePreview(object.source)"
              >mdi-close-box</v-icon
            >
          </span>
        </div>
        <div
          v-if="object.type == 'prematch'"
          class="tournament-card-events"
          v-for="(group, date) in groupByDate(object.events)"
          :key="$uuid.v1()"
        >
          <div class="bar-info">
            <v-col xs="4" class="no-padding left-info">
              <span class="date">{{ date }}</span>
            </v-col>
            <v-col
              xs="8"
              class="no-padding group-sign"
              v-for="(market, index) in object.markets"
              v-if="index == 0 && index < 2"
              :key="$uuid.v1()"
            >
              <span
                class="sign"
                v-for="(outcome, index_mrk) in market.outcomes"
                :key="$uuid.v1()"
              >
                {{ outcome.name }} {{ getSpecifiers(market.specifiers) }}
              </span>
              <span class="sign"></span>
            </v-col>

            <!-- use this if take configuration from market view settings -->
            <!--                        <v-col xs="8" class="no-padding group-sign"-->
            <!--                               v-for="(elemMarket,index) in object.headerSign"  v-if="index == 0 && index <2" :key="'default_header_mobile_'+index">-->
            <!--                          <span class="sign" v-for="(outcome,index) in elemMarket.outcomeNames" :key="'default_header_outcome_mobile_'+index">-->
            <!--                          {{ outcome }}-->
            <!--                          </span>-->
            <!--                            <span class="sign"></span>-->
            <!--                        </v-col>-->
          </div>
          <div
            class="event"
            v-for="(event, index) in group"
            :key="$uuid.v1()"
            :class="index % 2 == 0 ? 'even' : 'odd'"
          >
            <v-col
              :xs="4"
              class="no-padding info-event"
              @click="
                getDetailOfEvent(
                  event.id,
                  event.type,
                  object.sport.id,
                  event.tournament.id ? event.tournament.id : '',
                  event.status
                )
              "
            >
              <span class="competitors">
                <span class="home">{{ event.competitors.home.name }}</span>
                <span class="away">{{ event.competitors.away.name }}</span>
                <span class="time">
                  <v-icon x-small>mdi-timer</v-icon>
                  {{
                    new Date(event.scheduled).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                    })
                  }}
                </span>
              </span>
            </v-col>
            <v-col
              :xs="8"
              class="no-padding group-sign"
              v-for="(oddMarket, index) in event.odds"
              :key="$uuid.v1()"
              v-if="index == 0 && index < 2"
            >
              <div
                v-if="!oddMarket.void"
                class="odd"
                v-for="(odd, index) in oddMarket.odds"
                :key="$uuid.v1()"
              >
                <v-icon class="arrow-up" v-if="odd.type_change == 'up'"
                  >mdi-arrow-up</v-icon
                >
                <v-icon class="arrow-down" v-if="odd.type_change == 'down'"
                  >mdi-arrow-down</v-icon
                >
                <div
                  v-if="odd.outcome_odd_value > 0 && odd.active"
                  class="value"
                  :class="[
                    'multi-' + oddMarket.multiplicity_min,
                    getOddsSources.includes(odd.unique_id)
                      ? 'odd_selected'
                      : '',
                  ]"
                  @click="
                    putCart(
                      odd,
                      event,
                      object.sport,
                      object.category,
                      object.tournament
                    )
                  "
                >
                  <div
                    :class="[
                      odd.type_change != undefined ? odd.type_change : 'equal',
                    ]"
                  ></div>
                  {{ odd.outcome_odd_value | odds_type_filter }}
                </div>
                <div
                  v-else
                  class="value"
                  :class="'multi-' + oddMarket.multiplicity_min"
                >
                  <v-icon dense>mdi-lock</v-icon>
                </div>
              </div>

              <div
                v-if="oddMarket.void"
                class="odd"
                v-for="n in oddMarket.n_outcomes"
                :key="$uuid.v1()"
              >
                <div
                  class="value locked"
                  :class="'multi-' + oddMarket.multiplicity_min"
                >
                  <v-icon dense>mdi-lock</v-icon>
                </div>
              </div>

              <div class="odd">
                <div
                  v-if="event.count_odds > 0"
                  class="value"
                  @click="
                    getDetailOfEvent(
                      event.id,
                      event.type,
                      object.sport.id,
                      object.tournament.id ? object.tournament.id : '',
                      event.status
                    )
                  "
                  v-bind:class="{
                    'detail-opened': getEventsDetailActive.includes(event.id),
                  }"
                >
                  <span v-if="getOddsType == 'decimal'"
                    >+ {{ event.count_odds }}</span
                  >
                  <span v-if="getOddsType == 'american'">{{
                    $t('moreBets')
                  }}</span>
                </div>
                <div v-else class="value locked">
                  <v-icon dense>mdi-lock</v-icon>
                </div>
              </div>
            </v-col>
          </div>
        </div>
      </v-card>
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '../../../plugins/device-inspector'

export default {
  name: 'DefaultPreview',
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    attrs: {
      class: 'mb-6',
      boilerplate: true,
      elevation: 2,
    },
    loading: false,
    antepostType: ['stage', 'season', 'simple_tournament'],
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT +
      '/svg/categories/rectangular_flags_category/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/light/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons/',
    light: window.icons == 'light' ? true : false,
  }),
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getFilter: 'tree/getFilter',
      getPreview: 'odds/getPreview',
      getEventsDetailActive: 'odds/getEventsDetailActive',
      getLoadingPreview: 'odds/getLoadingPreview',
      getOddsSources: 'cart/getOddsSources',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getPlatformId: 'settings/getPlatformId',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
      getOddsType: 'odds/getOddsType',
    }),
  },
  methods: {
    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },
    ...mapActions({
      setFilter: 'tree/setFilter',
      removeFromPreview: 'odds/removeFromPreview',
      fetchEventDetail: 'odds/fetchEventDetail',
      setLoadingPreview: 'odds/setLoadingPreview',
      addOddToCart: 'cart/addOddToCart',
    }),

    removePreview(sourceTournament) {
      this.removeFromPreview({ source: sourceTournament })
    },

    groupByDate(events) {
      const refactored = _.groupBy(events, 'day')
      return refactored
    },

    async getDetailOfEvent(eventSource, type, sport, tournament, status) {
      document.body.scrollIntoView({ behavior: 'smooth' })
      window.parent.postMessage(
        {
          type: 'scrollTop',
        },
        '*'
      )
      await this.setLoadingPreview({ status: true })
      await this.fetchEventDetail({
        source: eventSource,
        group: 0,
        sport: sport,
        tournament: tournament,
        status: status,
      })
      await this.setLoadingPreview({ status: false })
    },

    async putCart(odd, event, sport, category, tournament) {
      if (odd.outcome_odd_value > 0 && odd.active) {
        await this.addOddToCart({
          odd: odd,
          event: event,
          sport: sport,
          category: category,
          tournament: tournament,
        })
        this.$root.$emit('forceUpdateSingleMultiple')
        this.$root.$emit('forceUpdateIntegral')
        this.$root.$emit('forceUpdateSystem')
      }
    },

    getSpecifiers(spec) {
      let result = ''
      if (spec.includes('#')) {
        const split = spec.split('#')
        if (split[1].includes(':')) {
          result = '(' + split[1] + ')'
        } else if (split[1].includes('(') && split[1].includes('.')) {
          result = ' [' + split[1] + '] '
        } else if (split[1] != '') {
          result = split[1]
        }

        if (_.size(split) > 2) {
          return result + ' ' + split[2]
        } else {
          return result
        }
      } else {
        return result
      }
    },
  },
}
</script>

<style>
.img-sport-light {
  filter: invert(1);
}

.img-sport-dark {
  filter: invert(0);
}
</style>
